module.exports = __webpack_public_path__ + "img/placeholder-module.32840eb9.png";